/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Pricing_PaidInputs */

const en_agent_authorization_pricing_paid = /** @type {(inputs: Agent_Authorization_Pricing_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const zh_agent_authorization_pricing_paid = /** @type {(inputs: Agent_Authorization_Pricing_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Agent_Authorization_Pricing_PaidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_pricing_paid = /** @type {((inputs?: Agent_Authorization_Pricing_PaidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Pricing_PaidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_pricing_paid(inputs)
	return zh_agent_authorization_pricing_paid(inputs)
});
export { agent_authorization_pricing_paid as "agent.authorization.pricing.paid" }